<template>
  <div>
    <div>
      <vxe-grid
        ref="table"
        show-overflow
        highlight-hover-row
        :loading="loading"
        :data="tableData"
        :height="tableHeight"
        :columns="tableColumns"
        :toolbar-config="tableToolbar"
        :radio-config="{
          trigger: 'row',
          highlight: true,
        }"
        row-key
        size="small"
        resizable
        border
        :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <b-col cols="9">
              <b-form onsubmit="return false">
                <b-input-group size="sm">
                  <el-select
                    v-model="value"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="请输入冷藏箱编号"
                    :remote-method="remoteMethod"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                  <b-button
                    size="sm"
                    class="ml-2"
                    variant="outline-success"
                    @click="add()"
                  >
                    <b-icon-plus></b-icon-plus>新增
                  </b-button>
                </b-input-group>
              </b-form>
            </b-col>
          </slot>
        </template>
        <template v-slot:opt="{ row }">
          <div>
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top"
            >
              <i class="el-icon-view tool-btn" @click="openEditDialog(row)"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <i
                class="el-icon-edit tool-btn"
                @click="openEditFormDialog(row)"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <i class="el-icon-delete tool-btn" @click="del(row)"></i>
            </el-tooltip>
          </div>
        </template>
      </vxe-grid>
      <el-dialog
        :title="title"
        v-if="dialogVisible"
        :visible.sync="dialogVisible"
        width="1200px"
        append-to-body
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <packing-icechops
              ref="icechops"
              :disabled="editVisible"
              :params="form"
            >
            </packing-icechops>
          </el-col>

          <el-col :span="12">
            <packing-thermometer
              ref="thermometer"
              :disabled="editVisible"
              :params="form"
            >
            </packing-thermometer>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import PackingIcechops from './packing-icechops'
import PackingThermometer from './packing-thermometer'

export default {
  components: { PackingIcechops, PackingThermometer },

  props: {
    params: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    falg: String,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      newdata: '',
      tableHeight: 350,
      backDialogVisible: false,
      dialogVisible: false,
      tableColumns: tableColumns(),
      formData: {
        waybillCode: this.waybillCode,
      },
      editVisible: false,
      title: '',
      options: [],
      value: '',
      list: [],
      states: [],
      form: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
    }
  },
  // 当父组件向子组件动态传值时，子组件props首次获取到父组件传来的默认值时，也需要执行函数，需要将immediate设为true
  watch: {
    params: {
      handler(params) {
        this.formData.wayBillSpecialChargesCode =
          params.wayBillSpecialChargesCode
        this.formData.waybillCode = params.waybillCode
        this.formData.waybillNo = params.waybillNo

        this.formData.dispatchOrderCode = params.dispatchOrderCode
        this.formData.dispatchOrderNo = params.dispatchOrderNo
        this.formData.orderCode = params.orderCode
        this.formData.orderNo = params.orderNo
      },
      immediate: true,
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    this.list = this.states.map((item) => {
      return { value: `value:${item}`, label: `${item}` }
    })
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .bizWaybillPackingListApi({
          dispatchOrderNo: this.params.dispatchOrderNo,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
      this.$api
        .bizWaybillCoolerApi()
        .then((res) => {
          this.loading = false
          // this.tableData = res.body.data
          this.list = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },

    remoteMethod(query) {
      if (query !== '') {
        this.options = this.list.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
        })
      }
    },
    add() {
      this.formData.coolerNo = this.value
      if (!this.formData.coolerNo) {
        this.$message.warning(`冷藏箱编号不能为空`)
        return
      }
      const index = this.tableData.findIndex((i) => {
        return i.boxNo == this.formData.coolerNo
      })
      if (index != -1) {
        this.$message.warning(`冷藏箱已经存在当前运单,请删除后重新添加`)
        return
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .bizWaybillCoolerSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.getData()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.options = []
          this.value = ''
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    openEditFormDialog(row) {
      this.form = row
      this.dialogVisible = true
      this.editVisible = false
      this.title = '编辑冰排/温度计信息'
    },
    openEditDialog(row) {
      this.form = row
      this.dialogVisible = true
      this.editVisible = true
      this.title = '查看冰排/温度计信息'
    },
    del(row) {
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .bizWaybillPackingDelApi(row)
        .then((res) => {
          loadingInstance.close()
          this.getData()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
